import { render, staticRenderFns } from "./clueDataDetails.vue?vue&type=template&id=f64c0c4e&scoped=true"
import script from "./clueDataDetails.vue?vue&type=script&lang=js"
export * from "./clueDataDetails.vue?vue&type=script&lang=js"
import style0 from "./clueDataDetails.vue?vue&type=style&index=0&id=f64c0c4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64c0c4e",
  null
  
)

export default component.exports